// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__TeogN","inputWrap":"Table_inputWrap__3qx9S","col":"Table_col__214uQ","bmiTooltip":"Table_bmiTooltip__9r16e"};